import { FEATURE_TOUR_IDS } from '@va/constants';

export const FeatureTourButtonContainer = () => {
  return <div id={FEATURE_TOUR_IDS.openTourContainerButton}></div>;
};
